import { Options, Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import { AspectRatioContainer, Image, styled } from "@volkswagen-onehub/components-core";
import React, { useEffect } from "react";
import { CardetailsInterface } from "..";

import '@splidejs/react-splide/css';
import { ArrowLeft, ArrowRight } from "@volkswagen-onehub/icons-core";
import { getLang } from "../../../translations";

export const PhotoContainer = styled.div`
    grid-column: 1 / -1;
    // margin-bottom: ${props => props.theme.size.static150};

    #details-vehicle-carousel, #details-vehicle-carousel--list {
        height: min-content;
        margin-bottom: 1rem;

        @media screen and (max-width: 560px) {
            margin-bottom: 0.5rem;
        }
    }

    #details-vehicle-carousel {
        margin-bottom: 1.5rem;

        #details-vehicle-carousel-list {
            height: unset;
        }
    }

    @media screen and (min-width: 1040px) {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
    }
`;

const MainPhotoContainer = styled.div`
    .splide__arrows {

        .splide__arrow {
            opacity: 1;
            border: 2px solid rgb(0, 30, 80);
            background-color: #001E50;

            svg {
                fill: #fff;
            }

            &.splide__arrow--prev {
                svg {
                    transform: scale(1) !important;
                    transform: rotateX(45deg);
                }
            }
        }
    }
`;

const ThumbnailContainer = styled.div`
    overflow-x: scroll;

    .splide__arrows {
        display: none;
    }

    .splide__slide.is-active {
        border: 3px solid #001E50 !important;
    }
`;

interface PhotosInterface extends CardetailsInterface {};

const mainOptions: Options = {
    type: 'loop',
    gap: '1rem',
    pagination: false
};

const thumbsOptions: Options = {
    type: 'slide',
    rewind: true,
    gap: '1rem',
    pagination: false,
    fixedWidth: 100,
    fixedHeight: 70,
    cover: true,
    focus: 'center',
    isNavigation: true,
    breakpoints: {
        560: {
            fixedWidth: 60,
            fixedHeight: 44,
            gap: '0.5rem'
        },
    },
};

export default ({ vehicle }: PhotosInterface) => {
    const photos = vehicle.photos;

    const mainRef = React.createRef<Splide>();

    const thumbsRef = React.createRef<Splide>();

    const lang = getLang();

    const getImageAlt = (slideNumber : number) => {
        let alt = '';
        if(vehicle.year && vehicle.model_name && photos.length) {
            if(lang == 'en') {
                alt += vehicle.year + ' ' + vehicle.model_name + ' ' + (slideNumber + 1) + ' of ' + photos.length;
            }
            else {
                alt +=  vehicle.model_name + ' ' +  vehicle.year + ' ' + (slideNumber + 1) + ' de ' + photos.length;
            }
        }
        return alt;
    }

    useEffect(() => {
        if (mainRef.current && thumbsRef.current && thumbsRef.current.splide) {
            mainRef.current.sync(thumbsRef.current.splide);
        }
    }, []);

    return photos && photos.length ?
        <PhotoContainer>
            <MainPhotoContainer>
                <Splide
                    id="details-vehicle-carousel"
                    hasTrack={false}
                    options={mainOptions}
                    aria-labelledby="thumbnail-slider-example"
                    ref={mainRef} >
                    <SplideTrack>
                    {
                        photos.map((photo, index) => {
                          const key = `photo-slide-${index}`
                            return <SplideSlide key={key}>
                                    <AspectRatioContainer ratio="3:2">
                                        <Image
                                            alt={getImageAlt(index)}
                                            objectFit="contain"
                                            src={photo.url}
                                        />
                                    </AspectRatioContainer>
                            </SplideSlide>
                        })
                    }
                    </SplideTrack>

                    <div className="splide__arrows">
                        <button className="splide__arrow splide__arrow--prev">
                            <ArrowLeft ariaLabel="Previous Slide" />
                        </button>
                        <button className="splide__arrow splide__arrow--next">
                            <ArrowRight ariaLabel="Next Slide" />
                        </button>
                    </div>

                </Splide>
            </MainPhotoContainer>

            <ThumbnailContainer>
                <Splide
                    id="details-vehicle-carousel--list"
                    ref={thumbsRef}
                    options={thumbsOptions}
                    aria-label="The carousel with thumbnails. Selecting a thumbnail will change the main carousel"
                >
                    {
                        photos.map((photo, index) => {
                          const key = `photo-thumbnail-${index}`
                            return <SplideSlide key={key}>
                                    <Image
                                        alt={photo.label as unknown as string}
                                        objectFit="cover"
                                        src={photo.url}
                                    />
                            </SplideSlide>
                        })
                    }
                </Splide>
            </ThumbnailContainer>

        </PhotoContainer> : null;
}
